export const OWNER_REGISTER = '/';
export const DASHBOARD = '/';
export const TRACKING_REPORT = '/trackingreport'
export const F2_PERFORMANCE = '/f2/detail/:f2UserId'
export const ORDER_SEARCHING = '/order';
export const CAR_FINDING = '/find';
export const CAR_FINDING_WD  = '/withdriver/find';
export const MY_TRIPS = '/mytrips';
export const TRIP_DETAIL = '/trip/detail/:tripId';
export const MY_WALLET = '/mywallet';
export const MY_MONTHLY_REPORT = '/mymonthlyreport/:month';
export const LOGIN = '/login';
export const FORBIDDEN = '/error';



// WEBPACK FOOTER //
// ./src/constant/routes.js